const RETURN_CTX_KEY = 'sofishr:returnPersonForm';
const documentsDraftKeyFor = (personId) => `sofishr:documentsDraft:${personId ?? 'unknown'}`;

function safeSetItem(key, value) {
    try {
        sessionStorage.setItem(key, JSON.stringify(value));
        return true;
    } catch {
        return false;
    }
}

function safeGetItem(key) {
    try {
        const raw = sessionStorage.getItem(key);
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
}

function safeRemoveItem(key) {
    try {
        sessionStorage.removeItem(key);
    } catch {
        // ignore storage errors
    }
}

export function saveDocumentsDraft(personId, values) {
    return safeSetItem(documentsDraftKeyFor(personId), {
        personId,
        values,
        savedAt: Date.now(),
    });
}

export function loadDocumentsDraft(personId) {
    const draft = safeGetItem(documentsDraftKeyFor(personId));
    if (!draft || draft.personId !== personId || !draft.values) {
        return null;
    }
    return draft;
}

export function clearDocumentsDraft(personId) {
    safeRemoveItem(documentsDraftKeyFor(personId));
}

export function savePersonFormReturnContext(context) {
    return safeSetItem(RETURN_CTX_KEY, context);
}

export function loadPersonFormReturnContext() {
    return safeGetItem(RETURN_CTX_KEY);
}

export function clearPersonFormReturnContext() {
    safeRemoveItem(RETURN_CTX_KEY);
}

